import { render, staticRenderFns } from "./ModalWithTabs.vue?vue&type=template&id=7e4c973c"
import script from "./ModalWithTabs.vue?vue&type=script&lang=js"
export * from "./ModalWithTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports